import { render, staticRenderFns } from "./AddressProofUpload.vue?vue&type=template&id=fc957784&scoped=true&"
import script from "./AddressProofUpload.vue?vue&type=script&lang=js&"
export * from "./AddressProofUpload.vue?vue&type=script&lang=js&"
import style0 from "./AddressProofUpload.vue?vue&type=style&index=0&id=fc957784&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc957784",
  null
  
)

export default component.exports